import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--text-copy"
export default class extends Controller {
  static targets = ["source"];
  connect() {}

  copyInnerText(e) {
    e.preventDefault();

    const text = this.sourceTarget.innerText;
    const pasteElement = document.querySelector(
      '[data-resumin--text-copy-target="paste"]'
    );

    pasteElement.value = text;

    pasteElement.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
